import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["testId", "label", "onClear"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { Text } from '@chakra-ui/react';
import { Dismiss, Icon } from '@whitbread-eos/atoms';
import { onActivationKeyDown } from './filterPanelKeyboard';
import { jsx as _jsx } from "react/jsx-runtime";
export function FilterPanelCloseButton(_ref) {
  var testId = _ref.testId,
    label = _ref.label,
    onClose = _ref.onClose;
  return _jsx(Icon, {
    svg: _jsx(Dismiss, {
      "data-testid": testId
    }),
    onClick: onClose,
    onKeyDown: onActivationKeyDown(onClose),
    role: "button",
    tabIndex: 0,
    "aria-label": label,
    style: {
      cursor: 'pointer'
    }
  });
}
export function FilterPanelClearButton(_ref2) {
  var testId = _ref2.testId,
    label = _ref2.label,
    onClear = _ref2.onClear,
    textProps = _objectWithoutProperties(_ref2, _excluded);
  return _jsx(Text, _objectSpread(_objectSpread({}, textProps), {}, {
    onClick: onClear,
    onKeyDown: onActivationKeyDown(onClear),
    role: "button",
    tabIndex: 0,
    "aria-label": label,
    "data-testid": testId,
    children: label
  }));
}